import React from "react";
import {
  bgColor,
  colorBlack,
  colorDarkBlue,
  colorDarkRed,
  colorLightGrey,
  colorWhite,
  primaryColor,
} from "../../../utility/constants/colorManager";
import { CustomButton } from "../main_comps/custom_button";
import { Divider } from "@mui/material";
import moment from "moment";

export const ClientDetialsForApproval = ({
  clientName,
  resellerName,
  onboardedTime,
  serviceType,
  serviceProvider,
  updatedAt,
  requestedBy,
}) => {
  return (
    <div>
      <p style={{ ...styles.mainTextStyle }}>{clientName}</p>
      <p style={{ ...styles.subTextStyle }}>{resellerName}</p>
      <p
        style={{
          ...styles.subTextStyle,
          fontSize: 13,
          color: "#7A7979",
          fontWeight: "400",
        }}
      >
        Requested by - {requestedBy} - {onboardedTime}
      </p>
    </div>
  );
};

function DeactivateUserComp({
  onClickCancel,
  isDividerRequired = true,
  data,
  id,
  onClickOK,
  loading,
  selectedId,
  userId,
  loading1 = false,
}) {
  return (
    <div
      style={{
        padding: "0px 10px",
        marginTop: 10,
      }}
      key={id}
    >
      <ClientDetialsForApproval
        clientName={data?.firstName + " " + data.lastName}
        onboardedTime={moment(data["updatedAt"]).format(
          "DD/MM/YYYY hh:mm:ss A"
        )}
        requestedBy={data?.deactivatedBy?.userName}
        resellerName={data?.resellerName}
        updatedAt={data?.updatedAt}
      />

      <div
        style={{
          marginTop: 20,
        }}
      >
        <p
          style={{
            color: "#E74242",
            fontSize: 12,
          }}
        >
          Message
        </p>
        <div
          style={{
            minHeight: 80,
            borderRadius: 3,
            backgroundColor: colorLightGrey,
          }}
        >
          <textarea
            disabled="true"
            type="textarea"
            style={{
              width: "100%",
              border: "none",
              outline: "none",
              paddingLeft: 20,
              paddingTop: 10,
              backgroundColor: colorLightGrey,
            }}
            value={data?.deactivatedBy?.reason}
            multiple={true}
            className="textarea1"
          />
        </div>
      </div>

      <div
        style={{
          display: "flex",
          gap: 20,
          justifyContent: "center",
          marginTop: 30,
          marginBottom: 20,
        }}
      >
        <CustomButton
          title="Cancel"
          styles={{
            backgroundColor: colorWhite,
            border: "1px solid black",
            padding: 0,
            height: "auto",
            padding: "13px 10px",
          }}
          textStyles={{
            color: colorBlack,
          }}
          onClick={onClickCancel}
          loading={loading1 && userId === selectedId ? true : false}
        />{" "}
        <CustomButton
          title="Deactivate account"
          styles={{
            backgroundColor: colorDarkBlue,
            border: "none",
            padding: 0,
            height: "auto",
            padding: "15px 40px",
          }}
          textStyles={{
            color: colorWhite,
          }}
          onClick={() => {
            onClickOK();
          }}
          disabled={false}
          loading={loading && userId === selectedId ? true : false}
        />
      </div>
      {isDividerRequired && <Divider />}
    </div>
  );
}

const styles = {
  mainTextStyle: {
    fontSize: 16,
    fontWeight: "600",
    color: primaryColor,
    margin: "5px 0px",
  },
  subTextStyle: {
    color: "#6C6B6B",
    fontWeight: "600",
    fontSize: 15,
    margin: "5px 0px",
  },
};

export default DeactivateUserComp;
